import "./Home.css";
import React, {Component} from "react";
import pagesStyle from "assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import HomeElementGridContainer from "./HomeElements/HomeElementGridContainer";
import {request} from '../../api-client'
import localization from '../../config/localization';
import GridItem from "./HomeElements/GridItem";
import EventManager, {events} from "../../utils/EventManager";
import HomeElementCarousel from "./HomeElements/HomeElementCarousel";
import ErrorBoundary from "../../components/Letflow/ErrorBoundary";
import DefaultBanner from "./HomeElements/DefaultBanner";
import {
  getActiveClient,
  setPageTitle
} from "../../api-client/core/authentication/utils";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {pushIfDoesNotExist} from "../../utils";
import PrevArrow from "../../components/Letflow/Arrows/PrevArrow";
import NextArrow from "../../components/Letflow/Arrows/NextArrow";
import BloomSpinner from "../../assets/img/bloom_spinner_grey.gif";
import Slider from "react-slick";
import InfiniteScroll from "react-infinite-scroll-component";

class Home extends Component {

  constructor(props) {
    super(props)
    this.state = {
      banners: [],
      loading: true,
      failedLoading: false,
      homeElementsMetadata: props.homeElements,
      homeElements: [],
      playlistFavorites: [],
      contentCreatorsFavorites: [],
      contentCreationsFavorites: [],
      pageReady: false,
      currentPage: 0,
      tempElements: []
    }
  }

  componentDidMount = () => {
    this.requestFavorites().then(() => this.requestHomeElements())

    setPageTitle(localization.get('title.home'))
    EventManager.getInstance().subscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToFavorites)
    EventManager.getInstance().subscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromFavorites)

    if (window.location.href.indexOf('?contenido=') > 0) {
      const urlParameter = window.location.href.split("?")[1].split('=');
      const content = urlParameter[1].split('-');
      const contentId = content[0]
      content.shift()

      EventManager.getInstance().dispatch(events.OPEN_CONTENT_MODAL, {
        id: contentId,
        dataType: urlParameter[0],
        dataName: content.toString()
      });
    }
  }

  componentWillUnmount = () => {
    EventManager.getInstance().unsubscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToFavorites)
    EventManager.getInstance().unsubscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromFavorites)
    sessionStorage.setItem("home_scroll_position", document.documentElement.scrollTop)
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (prevState.tempElements !== this.state.tempElements) {
      const {tempElements, homeElements, homeElementsMetadata} = this.state;

      const someFunction = () => {
        const lastElement = homeElements[homeElements.length - 1];
        let addIndex = homeElementsMetadata.find(cem => cem.type === 'banner') ? 1 : 0;
        let nextElementIndex = addIndex;
        if (lastElement) {
          nextElementIndex = homeElementsMetadata.findIndex(cem => cem.id === lastElement.id) + addIndex;
        }

        const lastElementToAdd = tempElements.find(te => {
          const nextElementMetadata = homeElementsMetadata[nextElementIndex];
          return nextElementMetadata && te.id === nextElementMetadata.id;

        });
        if (lastElementToAdd) {
          pushIfDoesNotExist(homeElements, lastElementToAdd);
          someFunction();
        }
      }

      tempElements.forEach(() => someFunction());


      this.setState({homeElements});
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props !== nextProps) {
      if (!nextProps.showModal) {
        if (window.location.href.indexOf('?contenido=') > 0) {
          const urlParameter = window.location.href.split("?")[1].split('=');
          const content = urlParameter[1].split('-');
          const contentId = content[0]
          content.shift()

          EventManager.getInstance().dispatch(events.OPEN_CONTENT_MODAL, {
            id: contentId,
            dataType: urlParameter[0],
            dataName: content.toString()
          });
        }
      }
    }
  }

  addToFavorites = ({id, type = 'content_creator'}) => {
    let {playlistFavorites, contentCreatorsFavorites, contentCreationsFavorites} = this.state
    switch (type) {
      case 'playlist':
        playlistFavorites.push(id)
        request.playlist.addFavorite(id);
        break
      case 'content_creator':
        contentCreatorsFavorites.push(id)
        request.contentCreatorFavorite.add(id)
        break
      case 'video_content_creation':
        contentCreationsFavorites.push(id)
        request.contentCreationFavorite.add(id)
        break
    }
    this.setState({ playlistFavorites, contentCreatorsFavorites, contentCreationsFavorites })
  }

  removeFromFavorites = ({id, type = 'content_creator'}) => {
    let { playlistFavorites, contentCreatorsFavorites, contentCreationsFavorites} = this.state
    switch (type) {
      case 'playlist':
        if (playlistFavorites.indexOf(id) > -1) {
          playlistFavorites.splice(playlistFavorites.indexOf(id), 1)
        }
        request.playlist.removeFavorite(id)
        break
      case 'content_creator':
        if (contentCreatorsFavorites.indexOf(id) > -1) {
          contentCreatorsFavorites.splice(contentCreatorsFavorites.indexOf(id), 1)
        }
        request.contentCreatorFavorite.remove(id)
        break
      case 'video_content_creation':
        if (contentCreationsFavorites.indexOf(id) > -1) {
          contentCreationsFavorites.splice(contentCreationsFavorites.indexOf(id), 1)
        }
        request.contentCreationFavorite.remove(id)
        break
    }
    this.setState({ contentCreatorsFavorites, contentCreationsFavorites})
  }

  requestHomeElements = () => {
    if (!this.state.requesting) {
      this.setState({
          currentPage: this.state.currentPage + 1,
          requesting: false,
        }, () => {
          this.state.homeElementsMetadata
            .slice(this.state.currentPage === 1 ? 0 : 5 * (this.state.currentPage - 1), 5 * this.state.currentPage)
            .forEach(element => {
              if (element.type === "banner") {
                if (element.items.data && element.items.data.length > 0) {
                  this.setState({banners: element.items.data, loading: false})
                } else {
                  this.setState({loading: false, requesting: false})
                }
              } else {
                request.home.getElementById(element.id).then(homeElement => {
                  this.setState(prevState => ({
                    tempElements: prevState.tempElements.concat([homeElement]),
                    requesting: false
                  }))
                })
              }
            })
        }
      )
    }
  }

  requestFavorites = () => new Promise(resolve => {
    request.playlist.getFavorites().then(playlistFavorites => this.setState({ playlistFavorites }))
    request.contentCreatorFavorite.getAll().then(contentCreatorsFavorites => this.setState({ contentCreatorsFavorites }))
    request.contentCreationFavorite.getAll().then(contentCreationsFavorites => this.setState({ contentCreationsFavorites }))
    resolve()
  })

  addAboutToHomeElements = () =>
    <InfiniteScroll
      style={{overflow: 'hidden'}}
      dataLength={this.state.homeElements.length}
      next={this.requestHomeElements}
      hasMore={this.state.homeElementsMetadata.length > this.state.homeElements.length + 1}
      loader={<div
        style={{height: "70px", paddingTop: 20, width: "100%", display: "flex", justifyContent: "center", alignContent: "center"}}
      >
        <img style={{width: 50, height: 50}} src={BloomSpinner} alt="Loading logo"/>
      </div>}
    >
      {this.state.homeElements.map(homeElement => {
        return (
          homeElementToComponent(
            this.props,
            this.state.playlistFavorites,
            this.state.contentCreatorsFavorites,
            this.state.contentCreationsFavorites,
            () => !this.state.pageReady && this.setState({pageReady: true})
          )(homeElement)
        )
      })}
    </InfiniteScroll>


  render = () => {

    let bannerSettings = {
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      beforeChange: () => EventManager.getInstance().dispatch(events.CHANGE_VIDEO_SLIDER_BANNER),
      onSwipe: () => EventManager.getInstance().dispatch(events.CHANGE_VIDEO_SLIDER_BANNER),
      prevArrow: <PrevArrow
        home={true}
        className={"banner-arrow"}
        overrideStyle={{transform: `translate(0, -${window.innerWidth < 770 ? 55 : 215}%)`, marginLeft: window.innerWidth < 770 ? 20 : 50, zIndex: 100, cursor: "pointer", fontSize: 50, color: "rgba(255,255,255,0.6)"}}
      />,
      nextArrow: <NextArrow
        home={true}
        className={"banner-arrow"}
        overrideStyle={{transform: `translate(0, -${window.innerWidth < 770 ? 55 : 215}%)`, marginRight: window.innerWidth < 770 ? 20 : 50,zIndex: 100, cursor: "pointer", fontSize: 50, color: "rgba(255,255,255,0.6)"}}/>,
      dots: false,
      responsive: [
        {
          breakpoint: 2000,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    };

    if (this.state.failedLoading) {
      return <div>Algo salio mal, refresque la pagina</div>
    } else {
      return (
        <div style={{paddingBottom: "40px"}} id="innerinner">
          {!this.state.loading ?
            <>
              {this.state.banners.length &&
              <>
                {this.state.banners.length > 0 ?
                  <Slider {...bannerSettings} >
                    {this.state.banners.sort(() => Math.random() - 0.5).map(banner =>
                      <DefaultBanner banner={banner}/>
                    )}
                  </Slider>
                  :
                  <DefaultBanner banner={this.state.banners[0]}/>
                }
              </>
              }
              {this.addAboutToHomeElements()}
            </> :
            <SkeletonTheme color={"#ddd"}>
              <Skeleton height={550} duration={1.5}/>
              <br/><br/>
              <br/><br/>
              <Skeleton height={50} duration={1.5}/>
              <br/>
              <br/>
              <span style={{marginLeft: "1%", marginRight: ".5%"}}>
                <Skeleton height={250} duration={1.5} width={"23.5%"}/>
              </span>
              <span style={{marginLeft: ".5%", marginRight: ".5%"}}>
                <Skeleton height={250} duration={1.5} width={"23.5%"}/>
              </span>
              <span style={{marginLeft: ".5%", marginRight: ".5%"}}>
                <Skeleton height={250} duration={1.5} width={"23.5%"}/>
              </span>
              <span style={{marginLeft: ".5%", marginRight: "1%"}}>
                <Skeleton height={250} duration={1.5} width={"23.5%"}/>
              </span>
            </SkeletonTheme>
          }
        </div>
      )
    }
  }
}

const makeHomeElementProp = (homeElement, playlistFavorites, contentCreatorsFavorites, contentCreationsFavorites) => {
  switch (homeElement.data_source) {
    case 'content_creator':
      return {
        ...homeElement,
        items: {
          data: homeElement.items.data.map(item => ({
            ...item,
            title: item.name,
            shortDescription: item.description,
            kind: homeElement.data_source,
            favorite: (contentCreatorsFavorites &&  homeElement.data_source === "content_creator")
              ? contentCreatorsFavorites.includes(item.id)
                : false,
          }))
        }
      }

    case 'playlist':
      return {
        ...homeElement,
        items: {
          data: homeElement.items.data.map(item => ({
            ...item,
            title: item.name,
            shortDescription: item.description,
            kind: 'content_creator',
            favorite: (contentCreatorsFavorites && homeElement.data_source === "content_creator")
              ? contentCreatorsFavorites.includes(item.id)
              : false,
          }))
        }
      }

    case 'video_content_creation':
      return {
        ...homeElement,
        items: {
          data: homeElement.items.data.map(item => ({
            ...item,
            title: item.title,
            shortDescription: item.description,
            kind: homeElement.data_source,
            favorite: (contentCreationsFavorites &&  homeElement.data_source === "video_content_creation")
              ? contentCreationsFavorites.includes(item.id)
              : false,
          }))
        }
      }
    case 'production':
      return {
        ...homeElement,
        items: {
          data: homeElement.items.data.map(item => ({
            ...item,
            title: item.project_name,
            shortDescription: item.project_details,
            kind: homeElement.data_source
          }))
        }
      }
    case 'recommended':
      const data = homeElement.items.data.map(item => ({
        ...item,
        recentlyCreated: item.recently_created,
        recentlyUpdated: item.recently_updated,
        shortDescription: item.short_description,
        description: item.description,
        longDescription: item.long_description,
        tracks: item.musics,
        favorite: playlistFavorites.includes(item.id),
      }))

      const nonPlaylists = data.filter(x => x.kind !== 'playlist')
      const playlists = data.filter(x => x.kind === 'playlist')

      return { ...homeElement, items: { data: nonPlaylists.concat(playlists) } }

    default:
      return {
        ...homeElement,
        items: {
          data: homeElement.items.data.map(item => ({
            ...item,
            title: item.name,
            shortDescription: item.description,
            kind: homeElement.data_source,
            favorite: (contentCreatorsFavorites &&  homeElement.data_source === "content_creator")
              ? contentCreatorsFavorites.includes(item.id)
              : false,
          }))
        }
      }
  }
}

const compareValues = (key, order = 'asc') => {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    }

    const varA = (typeof a[key] === 'string') ?
      a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string') ?
      b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return (
      (order === 'desc') ? (comparison * -1) : comparison
    );
  };
}

const makeTrackTypeProp = homeElement => {
  switch (homeElement.data_source) {
    case 'user_library':
      return (itemType) => itemType
    default:
      return () => 'music'
  }
}

const makeDataTypeProp = homeElement => {
  switch (homeElement.data_source) {
    case 'voice_over':
      return 'speaker';
    default:
      return 'album';
  }
}

const makeRequestElementProp = (homeElement) => {
  switch (homeElement.data_source) {
    case 'recommended':
      return async (id, itemKind) => {
        if (itemKind === 'playlist') {
          const playlist = await request.playlist.getGlobal(id)

          const selectedTags = playlist.tags.filter(tag => tag.wanted === 1).map(tag => tag.id)
          const unselectedTags = playlist.tags.filter(tag => tag.wanted === 0).map(tag => tag.id)

          const tracks = await request.music.getAllByPlaylistForClient(getActiveClient(), id, selectedTags, unselectedTags, playlist.query || '', "audio:id,duration,url")
          return {
            ...playlist,
            tracks,
            kind: itemKind,
          }
        }
      }
    default:
      return albumId => request.album.getForClient(albumId, 'include=image;artist')
        .then(album =>
          request.music.getAllByAlbumForClient(getActiveClient(), albumId, 'include=versions_count;audio:id,duration,url;tags;favorite;audio.waveform;albums.image;artist', album.type === 'library' ? 'created_at' : null, album.type === 'library' ? 'desc' : null)
            .then(musics => ({
              ...album,
              tracks: musics.map(music => ({ ...music, type: 'music' })),
              longDescription: album.long_description,
              shortDescription: album.short_description,
            }))
        )
  }
}

const homeElementToComponent = (props, playlistFavorites, contentCreatorsFavorites, contentCreationsFavorites, setPageReady) => homeElement => {
  let component

  switch (homeElement.type) {
    case 'banner':
      component = <DefaultBanner banner={homeElement.items.data} />
      break
    case 'default_banner':
      component = <DefaultBanner banner={homeElement.items.data} />
      break
    case 'grid':
      switch (homeElement.columns) {
        case 6:
          component = <HomeElementGridContainer
            {...props}
            maxPerRow={6}
            shape={homeElement.shape}
            fixedTitle={homeElement.fixed_title}
            withBackground={homeElement.with_background}
            homeElement={makeHomeElementProp(homeElement, playlistFavorites, contentCreatorsFavorites, contentCreationsFavorites)}
            trackType={makeTrackTypeProp(homeElement)}
            dataType={makeDataTypeProp(homeElement)}
            requestElement={makeRequestElementProp(homeElement)}
            sizes={{
              xs: 6,
              sm: 4,
              md: 3,
              lg: 2,
              xl: 2,
            }}
            itemComponent={GridItem}
            showMore={!!homeElement.rows_to_show}
            rowsToShow={homeElement.rows_to_show}
            home={true}
          />
          break
        case 4:
          component = <HomeElementGridContainer
            {...props}
            maxPerRow={4}
            shape={homeElement.shape}
            fixedTitle={homeElement.fixed_title}
            withBackground={homeElement.with_background}
            homeElement={makeHomeElementProp(homeElement, playlistFavorites, contentCreatorsFavorites, contentCreationsFavorites)}
            trackType={makeTrackTypeProp(homeElement)}
            dataType={makeDataTypeProp(homeElement)}
            requestElement={makeRequestElementProp(homeElement)}
            sizes={{
              xs: 12,
              sm: 4,
              md: 3,
              lg: 3,
              xl: 3,
            }}
            itemComponent={GridItem}
            showMore={!!homeElement.rows_to_show}
            rowsToShow={homeElement.rows_to_show}
            home={true}
          />
          break
        default:
          component = null
      }
      break
    case 'featured':
    case 'carousel':
      component = <HomeElementCarousel
        {...props}
        playlistFavorites={playlistFavorites}
        contentCreatorsFavorites={contentCreatorsFavorites}
        contentCreationsFavorites={contentCreationsFavorites}
        onlyImage={homeElement.only_image}
        numbered={homeElement.numbered}
        shape={homeElement.shape}
        inverted={homeElement.inverted}
        editorial={homeElement.editorial}
        columns={homeElement.columns}
        homeElement={makeHomeElementProp(homeElement, playlistFavorites, contentCreatorsFavorites, contentCreationsFavorites)}
        trackType={makeTrackTypeProp(homeElement)}
        dataType={makeDataTypeProp(homeElement)}
        requestElement={makeRequestElementProp(homeElement)}
      />
      break
    default:
      component = null
  }

  // If the element does not have elements to show, dont display it unless its a banner.
  // Banners should still be shown as they will be rendered with another provided media.
  if (homeElement.type !== 'banner' && homeElement.items.data.length === 0) {
    component = null
  }

  setPageReady()

  return <ErrorBoundary>{component}</ErrorBoundary>
}

export default withStyles(pagesStyle)(Home);
